import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10858a32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "theme-content" }
const _hoisted_2 = {
  class: "list-cat",
  ref: "intelliSense"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head-wrap" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "お題の編集")
], -1))
const _hoisted_5 = { class: "tool" }
const _hoisted_6 = { class: "search" }
const _hoisted_7 = { class: "filter" }
const _hoisted_8 = { class: "search-tool" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "add", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("新規作成 ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "save" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "save", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("変更の保存 ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 1,
  class: "theme-list-loading"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot-pulse" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "theme-wrap"
}
const _hoisted_21 = { ref: "list" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onInput"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "×", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "theme" }
const _hoisted_30 = {
  key: 0,
  class: "theme-text"
}
const _hoisted_31 = ["onInput"]
const _hoisted_32 = {
  key: 1,
  class: "theme-plane"
}
const _hoisted_33 = {
  key: 2,
  class: "theme-ctl"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete_outline", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 3,
  class: "active-info"
}
const _hoisted_38 = { class: "theme-info" }
const _hoisted_39 = { class: "author" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.showIntelliSence)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "intelli-sense",
          style: _normalizeStyle(_ctx.state.style)
        }, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass({ active: _ctx.state.currentChoiseIndex == index }),
                key: category.id,
                onClick: ($event: any) => (_ctx.choice(category.name))
              }, _toDisplayString(category.name), 11, _hoisted_3))
            }), 128))
          ], 512)
        ], 4))
      : _createCommentVNode("", true),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "文字検索",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.searchText) = $event))
        }, null, 512), [
          [_vModelText, _ctx.state.searchText]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", {
            class: _normalizeClass({active:_ctx.state.searchCats.includes(-1)}),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search(-1)))
          }, "自分の", 2),
          _createElementVNode("li", {
            class: _normalizeClass({active:_ctx.state.searchCats.includes(-2)}),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search(-2)))
          }, "有効", 2),
          _createElementVNode("li", {
            class: _normalizeClass({active:_ctx.state.searchCats.includes(-3)}),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search(-3)))
          }, "無効", 2)
        ])
      ]),
      _createElementVNode("div", {
        class: "addTheme",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addTheme && _ctx.addTheme(...args)))
      }, _hoisted_11),
      _createElementVNode("div", _hoisted_12, [
        (!_ctx.saveLoading)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, _hoisted_15))
          : (_openBlock(), _createElementBlock("p", _hoisted_16, "更新中"))
      ])
    ]),
    (_ctx.themesLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_TransitionGroup, {
              name: "list",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.newThemes, (theme) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "new-theme-block",
                    key: theme.id,
                    onClick: ($event: any) => (_ctx.state.currentNewTheme = theme),
                    ref_for: true,
                    ref: "list"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["theme-input", {
                error1: theme.errors ? theme.errors.includes(0):false,
                error2: theme.errors ? theme.errors.includes(1):false,
                error3: theme.errors ? theme.errors.includes(2):false,
                error4: theme.errors ? theme.errors.includes(3):false
              }]),
                      contenteditable: "true",
                      onInput: ($event: any) => (_ctx.input($event, theme)),
                      onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.keydown && _ctx.keydown(...args))),
                      onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.isUpdate=false))
                    }, _hoisted_25, 42, _hoisted_23),
                    _createElementVNode("div", {
                      class: "remove",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.removeNewTheme && _ctx.removeNewTheme(...args)))
                    }, _hoisted_27)
                  ], 8, _hoisted_22))
                }), 128))
              ]),
              _: 1
            })
          ], 512),
          _createVNode(_TransitionGroup, {
            class: "list-theme",
            tag: "div",
            name: "list2",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterThemes, (theme) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: theme.id,
                  onClick: ($event: any) => {_ctx.state.currentTheme = theme;},
                  class: _normalizeClass({
            'theme-block': true,
            delete: _ctx.state.delThemeIds.includes(Number(theme.id)),
          })
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    (theme.author.uuid == _ctx.user.uuid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["theme-input", {
                  error1: theme.errors ? theme.errors.includes(0):false,
                  error2: theme.errors ? theme.errors.includes(1):false,
                  error3: theme.errors ? theme.errors.includes(2):false,
                  error4: theme.errors ? theme.errors.includes(3):false
                }]),
                            contenteditable: "true",
                            onInput: ($event: any) => (_ctx.updateInput($event, theme)),
                            onKeydown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.keydown && _ctx.keydown(...args))),
                            onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.isUpdate=true))
                          }, [
                            _createElementVNode("div", null, _toDisplayString(theme.theme), 1)
                          ], 42, _hoisted_31)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(theme.theme), 1)),
                    (theme.author.uuid == _ctx.user.uuid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ 'btn-toggle': true, active: theme.active }),
                            onClick: ($event: any) => (_ctx.toggleActive(theme))
                          }, null, 10, _hoisted_34),
                          _createElementVNode("div", {
                            class: "trash",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.delTheme && _ctx.delTheme(...args)))
                          }, _hoisted_36)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(theme.active?"有効":"無効"), 1))
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.format(theme.updatedAt)) + "：" + _toDisplayString(theme.author.nickname), 1)
                  ])
                ], 10, _hoisted_28))
              }), 128))
            ]),
            _: 1
          })
        ]))
  ]))
}